import { colors, spacing } from './common';
import { MainThemeColors } from './types';

const kennectedPrimaryColors: MainThemeColors = {
  primary: {
    100: '#017a20',
    80: 'rgba(1, 122, 32, 0.8)',
    60: 'rgba(1, 122, 32, 0.6)',
    40: 'rgba(1, 122, 32, 0.4)',
    20: 'rgba(1, 122, 32, 0.2)',
    10: 'rgba(1, 122, 32, 0.1)',
    5: 'rgba(1, 122, 32, 0.05)',
    hover: {
      borderColor: 'rgba(39, 42, 50, 0.2)',
    },
    focus: {
      borderColor: 'rgba(39, 42, 50, 0.2)',
    },
  },
  secondary: {
    100: '#fc3555',
    80: 'rgba(252, 53, 85, 0.8)',
    60: 'rgba(252, 53, 85, 0.6)',
    40: 'rgba(252, 53, 85, 0.4)',
    20: 'rgba(252, 53, 85, 0.2)',
    10: 'rgba(252, 53, 85, 0.1)',
    5: 'rgba(252, 53, 85, 0.05)',
    non_alpha: '#F7F9FA',
  },
};

export const kennected = {
  colors: {
    ...kennectedPrimaryColors,
    ...colors,
  },
  spacing,
};
